import { render, staticRenderFns } from "./teacherIntroduce.vue?vue&type=template&id=1400b1d0&scoped=true"
import script from "./teacherIntroduce.vue?vue&type=script&lang=js"
export * from "./teacherIntroduce.vue?vue&type=script&lang=js"
import style0 from "./teacherIntroduce.vue?vue&type=style&index=0&id=1400b1d0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1400b1d0",
  null
  
)

export default component.exports